export default __webpack_public_path__ + "static/media/Red0003.d9c32738.png";